import * as fetchActions from './fetch';

export default {
  ...fetchActions,
};
